var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.598,
    height: 25,
    viewBox: "0 0 24.598 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "google",
    d: "M24.6 20.792C24.6 27.924 19.713 33 12.5 33a12.5 12.5 0 1 1 0-25 12.021 12.021 0 0 1 8.382 3.271l-3.4 3.271C13.029 10.248 4.753 13.474 4.753 20.5a7.83 7.83 0 0 0 7.747 7.893c4.95 0 6.8-3.548 7.1-5.388h-7.1v-4.3h11.9a10.958 10.958 0 0 1 .2 2.087z",
    className: "cls-1",
    transform: "translate(0 -7.999)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c1098080de2427e8e79222763c214767.svg";
export { ForwardRef as ReactComponent };